import { LibraryAddCheck } from "@mui/icons-material";
import {
  Autocomplete,
  TextField,
  Tooltip,
} from "@mui/material";
import MDBox from "components/MDBox";
import { useEffect, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";

export function SelectEmployee({
  onSelected,
  multiple,
  label,
  selectAll,
  fullWidth,
  placeholder,
  value
}) {
  const [employees, setEmployees] = useState([]);
  const [selected, setSelected] = useState(value ?? (multiple ? [] : null));
  const selectedValue = value !== undefined ? value : selected;

  useEffect(() => {
    setSelected(value ?? (multiple ? [] : null));
  }, [value, multiple]);

  useEffect(() => {
    getEmployee();
  }, []);
  async function getEmployee() {
    var res = await ApiCalls.getEmployeesList("?status=active");
    if (res.success && res.code === 200) {
      var data = JSON.parse(JSON.stringify(res.data));
    //  var d = flattenHierarchy(data) ;
      setEmployees(data);
    } else {
    }
  }
  function handleSelectAll() {
    setSelected(employees.map((e) => e.id));
  }

  return (
    <MDBox display="flex" flexDirection="row" alignItems="center">
      <Autocomplete
        id={label}
        value={
          multiple
            ? selectedValue?.map((e) => employees?.find((v) => v?.id == e)).filter(Boolean)
            : employees.find((v) => v.id == selectedValue) || null
        }
        options={employees}
        dense
        multiple={multiple}
        componentsProps={{ popper: { style: { width: "fit-content" } } }}
        fullWidth={fullWidth}
        isOptionEqualToValue={(option, selectedOption) => option?.id === selectedOption?.id}
        getOptionLabel={(option) =>
          Array.isArray(option)
            ? option.map(
                (item) => item?.user?.firstname + " " + item?.user?.lastname
              )
            : option?.user?.firstname + " " + option?.user?.lastname
        }
        renderInput={(params) => (
          <TextField
            {...params}
            name="Employee"
            label={label}
            placeholder={placeholder}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            sx={{
              width: fullWidth ? "100%" : 200,
              "& .MuiOutlinedInput-root": {
                minHeight: 56,
                borderRadius: "14px",
                backgroundColor: "var(--app-field-bg)",
              },
              "& .MuiInputLabel-root": {
                color: "var(--app-text-secondary)",
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
          var selectedValues;
          if (multiple) {
            selectedValues = Array.isArray(newValue)
              ? newValue.map((v) => v?.id)
              : [newValue?.id];
          } else {
            selectedValues = newValue?.id;
          }
          setSelected(selectedValues);
          onSelected(selectedValues);
        }}
      />
      {selectAll && (
        <Tooltip title="Select All">
          <LibraryAddCheck
            sx={{ cursor: "pointer", mt: 2, color: "var(--app-text-primary)" }}
            onClick={() => {
              handleSelectAll();
            }}
          />
        </Tooltip>
      )}
    </MDBox>
  );
}
